// @flow
import React, { Component } from 'react'
import Brief from './Brief'
import getJson from '../../services/getJson'
import postJson from '../../services/postJson'
import _ from 'lodash'
import scrollToTop from '../../shared/scrollToTop'
import { getMedia } from '../../redux/selectors'
import store from '../../redux/store'

const maxImageCount = 20

export type BriefData = {|
  ad_object: string,
  ad_object_type: 'site' | 'vk' | 'instagram',
  ad_target: string,
  ad_audience: string,
  product_best_sides: string,
  best_products: string,
  image_ids: Array<number>,
  visits_per_month: string,
  crm_existence: string,
  addresses: string,
  budget: string,
  comment: string,
  ad_duration: string
|}

export type PaymentMethod = 'robokassa' | 'bank' | 'card' | 'qiwi' | 'yandex' | 'webmoney'

type Props = {|
  adAccountId: number,
  roboUrl: string,
  bankUrl: string
|}

type State = {|
  brief: BriefData,
  response: ?Object,
  errors: Object,
  commonError: string,
  initialized: boolean,
  imageStoreIds: Array<string>,
  imagesError: string,
  paymentError: string,
  paymentMethod: PaymentMethod
|}

export default class BriefContainer extends Component<Props, State> {
  constructor(props: Object) {
    super(props)
    this.state = {
      brief: {
        ad_object: '',
        ad_object_type: 'site',
        ad_target: '',
        ad_audience: '',
        product_best_sides: '',
        best_products: '',
        image_ids: [],
        visits_per_month: '',
        crm_existence: '',
        addresses: '',
        budget: '',
        comment: '',
        ad_duration: ''
      },
      response: null,
      errors: {},
      commonError: '',
      initialized: false,
      imageStoreIds: [],
      imagesError: '',
      paymentMethod: 'card',
      paymentError: ''
    }
  }

  componentDidMount() {
    getJson('/api/v1/briefs').done((response) => {
      const data = response.data
      this.setState({ initialized: true })
      if (data) {
        this.setState({ brief: data, response: data })
      }
    })
  }

  render() {
    if (!this.state.initialized) return null
    return (
      <Brief
        data={this.state.brief}
        showSummary={!!this.state.response}
        errors={this.state.errors}
        commonError={this.state.commonError}
        imageStoreIds={this.state.imageStoreIds}
        imagesError={this.state.imagesError}
        onChange={(diff) => this.changed(diff)}
        onImagesLoad={(storeIds) => this.imageLoaded(storeIds)}
        onClear={() => {
          postJson('/api/v1/briefs/clear', {}).done(() => {
            this.setState({
              response: null,
              brief: {
                ad_object: '',
                ad_object_type: 'site',
                ad_target: '',
                ad_audience: '',
                product_best_sides: '',
                best_products: '',
                image_ids: [],
                visits_per_month: '',
                crm_existence: '',
                addresses: '',
                budget: '',
                comment: '',
                ad_duration: ''
              },
              imageStoreIds: []
            })
          })
        }}
        onSend={() => {
          const state = store.getState()
          postJson('/api/v1/briefs', {
            data: {
              ...this.state.brief,
              crm_existence: this.convertCrmExistenceValue(this.state.brief.crm_existence),
              image_ids: _.map(this.state.imageStoreIds, (storeId) => getMedia(state, storeId).id)
            }
          })
            .done((response) => {
              const data = response.data
              scrollToTop()
              this.setState({ response: data })
            })
            .fail((e: any) => {
              if (e.status === 422) {
                scrollToTop()
                this.setState({
                  errors: e.responseJSON.message,
                  commonError: 'Исправьте ошибки на форме и нажмите "Отправить" ещё раз',
                  imagesError: e.responseJSON.message['image_ids'] || ''
                })
              } else {
                window.alert('Internal error!')
              }
            })
        }}
        onRemoveImage={(storeId) => {
          this.setState({ imageStoreIds: _.without(this.state.imageStoreIds, storeId) })
        }}
        paymentMethod={this.state.paymentMethod}
        paymentError={this.state.paymentError}
        onPaymentMethodChange={(paymentMethod) => {
          this.setState({ paymentMethod })
        }}
        onPerformPayment={() => {
          this.setState({ paymentError: '' })
          const paymentUrl =
            this.state.paymentMethod === 'bank' ? this.props.bankUrl : this.props.roboUrl
          const amount = parseInt(this.state.brief.budget) * parseInt(this.state.brief.ad_duration)
          postJson(paymentUrl, {
            transaction: {
              amount: amount,
              ad_account_id: this.props.adAccountId,
              payment_method: this.state.paymentMethod
            }
          })
            .done((response) => {
              if (_.isEmpty(response.errors)) {
                if (response.notice) window.alert(response.notice)
                if (response.redirect_to) window.location.href = response.redirect_to
              } else {
                this.setState({ paymentError: response.errors })
              }
            })
            .fail(() => window.alert('Internal server error'))
        }}
      />
    )
  }

  convertCrmExistenceValue(value: any) {
    if (value === 'yes') return true
    if (value === 'no') return false
    return ''
  }

  imageLoaded(storeIds: Array<string>) {
    const imageStoreIds = this.state.imageStoreIds
    this.setState({
      imageStoreIds: [...imageStoreIds, ...storeIds].slice(0, maxImageCount),
      imagesError: '',
      commonError: ''
    })
  }

  changed(diff: Object) {
    const keys = _.keys(diff)
    const resetErrors = _.fromPairs(_.map(keys, (key) => [key, null]))
    this.setState({
      brief: { ...this.state.brief, ...diff },
      errors: { ...this.state.errors, ...resetErrors },
      commonError: ''
    })
  }
}
